"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNKNOWN = exports.ATTRIBUTES_KEYS_BY_TYPE = exports.PROMETHEUS_ENDPOINT_PATH = exports.PROMETHEUS_ENDPOINT_DOMAIN = exports.PROMETHEUS_ENDPOINT_NAME = exports.SA_ENDPOINT_NAME = exports.FIREBASE_ENDPOINT_NAME = exports.OFFLINE_MODE = exports.DOWNGRADE_MODE = exports.EXPORT_MODE = exports.SSR_MODE = void 0;

var _ATTRIBUTES_KEYS_BY_T;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SSR_MODE = 'ssr';
exports.SSR_MODE = SSR_MODE;
var EXPORT_MODE = 'export';
exports.EXPORT_MODE = EXPORT_MODE;
var DOWNGRADE_MODE = 'download';
exports.DOWNGRADE_MODE = DOWNGRADE_MODE;
var OFFLINE_MODE = 'offline';
exports.OFFLINE_MODE = OFFLINE_MODE;
var FIREBASE_ENDPOINT_NAME = 'firebase';
exports.FIREBASE_ENDPOINT_NAME = FIREBASE_ENDPOINT_NAME;
var SA_ENDPOINT_NAME = 'sa';
exports.SA_ENDPOINT_NAME = SA_ENDPOINT_NAME;
var PROMETHEUS_ENDPOINT_NAME = 'prometheus';
exports.PROMETHEUS_ENDPOINT_NAME = PROMETHEUS_ENDPOINT_NAME;
var PROMETHEUS_ENDPOINT_DOMAIN = {
  local: 'https://test-r.akulaku.net',
  dev: 'https://test-r.akulaku.net',
  test: 'https://test-r.akulaku.net',
  prod: 'https://r.akulaku.net'
};
exports.PROMETHEUS_ENDPOINT_DOMAIN = PROMETHEUS_ENDPOINT_DOMAIN;
var PROMETHEUS_ENDPOINT_PATH = '/performance/web';
exports.PROMETHEUS_ENDPOINT_PATH = PROMETHEUS_ENDPOINT_PATH;
var ATTRIBUTES_KEYS_BY_TYPE = (_ATTRIBUTES_KEYS_BY_T = {}, _defineProperty(_ATTRIBUTES_KEYS_BY_T, FIREBASE_ENDPOINT_NAME, {
  action: ['device_level'],
  network_api: ['pathname', 'no_response_data', 'protocol', 'is_https', 'no_download'],
  frame: ['device_level'],
  network_navigation: ['navigation_type', 'pathname', 'protocol', 'is_https', 'no_download'],
  page_perf: ['mode', 'device_level', 'need_net_resource', 'is_route_change', 'is_first_page']
}), _defineProperty(_ATTRIBUTES_KEYS_BY_T, PROMETHEUS_ENDPOINT_NAME, {
  action: ['device_level'],
  network_api: ['pathname', 'api_type', 'no_response_data'],
  frame: ['device_level'],
  network_navigation: ['navigation_type'],
  page_perf: ['mode', 'device_level', 'need_net_resource', 'is_route_change']
}), _ATTRIBUTES_KEYS_BY_T);
exports.ATTRIBUTES_KEYS_BY_TYPE = ATTRIBUTES_KEYS_BY_TYPE;
var UNKNOWN = 'UNKNOWN';
exports.UNKNOWN = UNKNOWN;